'use client'
import Image from 'next/image'
import { useMonkeCatalog } from '@/utils/hooks/useMonkeDiscovery'
import { useState } from 'react'

export default function MonkeArtwork({ id }: { id: string }) {
	const { byId, error, mutate } = useMonkeCatalog()
	const [failed, setFailed] = useState(false)
	const monke = byId.get(id)
	if (failed || error) return <p role="status" className="p-4 text-sm text-muted-foreground">Artwork unavailable. <button type="button" className="underline" onClick={() => { setFailed(false); void mutate() }}>Retry</button></p>
	if (!monke) return <div aria-label="Loading artwork" className="size-full animate-pulse bg-muted/30" />
	return <Image src={`/api/nodemonkes/${monke.number}/image`} alt={`NodeMonke #${monke.number}`} width={1120} height={1120} unoptimized priority onError={() => setFailed(true)} className="size-full object-contain" style={{ imageRendering: 'pixelated' }} />
}
